import React, { Component, PropTypes } from 'react';
import { NitroDivider, NitroLoading, NitroButton, NitroPanel } from 'nitro-components';

import QuoteCard from '../../components/summary/QuoteCard';

import { getFilteredQuestionAnswer, formatCurrency } from '../../helper';

import QuoteStatusList from './QuoteStatusList';

// Todo: refactoring into SummaryPanel
import SummarySection from './SummarySection';

import { IncludedExtras, ColourAndExtras } from '../../components/accordions';

import Delivery from '../../components/summary/Delivery';
import Lease from '../../components/summary/Lease';
import QuestionList from '../../components/Question/QuestionList';

import { VehicleDetails } from '../../../../components/vehicle';

import styled from 'styled-components';

import * as actions from '../actions';

const QuoteSummary = styled.section`

`

const QuoteSummaryDrawerContent = styled.div`
  padding: 0 30px;
  .summary-section {
    margin-top: 30px;
  }
`;

class QuoteDetails extends Component {
  componentWillReceiveProps(nextProps) {
    const { fetchQuoteSummary } = this.props.actions;

    if (nextProps.open !== this.props.open && nextProps.open) {
      fetchQuoteSummary(nextProps.quoteId, nextProps.countryCode, nextProps.companyCode);
    }
  }

  sendEmail = ({ ApproverId }) => {
    const { quoteId, companyCode, countryCode } = this.props;
    this.props.sendEmail({
      QuoteId: quoteId,
      ApproverId,
      CompanyCode: companyCode,
      CountryCode: countryCode
    });
  };

  exportQuote = () => {
    const { quoteId } = this.props;
    const { exportQuote } = this.props.actions;

    exportQuote(quoteId);
  };

  render() {
    const { fetchingQuoteSummary, emailList, statusList } = this.props;

    const {
      status,
      quoteId,
      cost,
      leaseTerms,
      includedExtras,
      selectedVehicle,
      selectedColour,
      optionalExtras,
      leaseDetails,
      deliveryDetails,
      questionList,
      registrationState
    } = this.props;

    const quoteSummary = (
      <QuoteSummary>
        <QuoteCard card={false} reference={quoteId} cost={formatCurrency(cost)} term={leaseTerms} />
        <QuoteSummaryDrawerContent>
          <QuoteStatusList
            quoteId={quoteId}
            title="Status"
            action={this.sendEmail}
            statusList={statusList}
            status={status}
            emailList={emailList}
          />
          <SummarySection title="Vehicle" step="1">
            <VehicleDetails {...selectedVehicle} horizontal showStats />
            <NitroDivider />
            <IncludedExtras options={includedExtras} />
            <NitroDivider />
            <ColourAndExtras selectedColour={selectedColour} selectedExtras={optionalExtras} />
          </SummarySection>
          <SummarySection title="Lease" step="2">
            <Lease leaseDetails={leaseDetails} registrationState={registrationState} />
          </SummarySection>

          <SummarySection title="Delivery" step="3">
            <Delivery {...deliveryDetails} />
          </SummarySection>

          <SummarySection title="Questions">
            <QuestionList list={getFilteredQuestionAnswer(questionList)} />
          </SummarySection>
        </QuoteSummaryDrawerContent>
        <NitroPanel>
          <NitroButton
            variant="secondary"
            label="Export quote"
            size="small"
            width="block"
            action={this.exportQuote}
            />
        </NitroPanel>
      </QuoteSummary>
    );
    const content = fetchingQuoteSummary ? <NitroLoading center /> : quoteSummary;

    return (
      <section>
        {content}
      </section>
    );
  }
}

QuoteDetails.propTypes = {
  statusList: PropTypes.array,
  status: PropTypes.object,
  fetchingQuoteSummary: PropTypes.bool,
  actions: PropTypes.object,
  open: PropTypes.bool,
  close: PropTypes.func,
  quoteId: PropTypes.string,

  cost: PropTypes.number,
  leaseTerms: PropTypes.string,
  includedExtras: PropTypes.array,
  selectedVehicle: PropTypes.object,
  selectedColour: PropTypes.object,
  optionalExtras: PropTypes.array,
  registrationState: PropTypes.string,
  leaseDetails: PropTypes.array,
  deliveryDetails: PropTypes.object,
  questionList: PropTypes.array,

  companyCode: PropTypes.string,
  countryCode: PropTypes.string,

  emailList: PropTypes.object.isRequired,
  sendEmail: PropTypes.func.isRequired
};

export default QuoteDetails;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteDetails.js